import request from './../common/request'
//设置token
export function setToken(data) {
    let expire = parseInt(new Date().getTime()) + (6 * 24 * 60 * 60 * 1000);
    const obj = {
        data,
        expire,
    };
    localStorage.setItem('cgxwOlympicToken', JSON.stringify(obj));
}

//获取token
export function getToken() {
    const storage = localStorage.getItem('cgxwOlympicToken');
    const time = new Date().getTime();

    if (storage) {
        const obj = JSON.parse(storage);

        if (time < new Date(obj.expire).getTime()) {
            return obj.data;
        } else {
            localStorage.removeItem('cgxwOlympicToken');
        }
    }
    return null;
}


//自由设置token
export function setMyToken(name, data) {
    let expire = parseInt(new Date().getTime()) + (20 * 24 * 60 * 60 * 1000);
    const obj = {
        data,
        expire,
    };
    localStorage.setItem(name, JSON.stringify(obj));
}

//获取自由设置的token
export function getMyToken(name) {
    const storage = localStorage.getItem(name);
    const time = new Date().getTime();

    if (storage) {
        const obj = JSON.parse(storage);

        if (time < obj.expire) {
            return obj.data;
        } else {
            localStorage.removeItem(name);
        }
    }
    return null;
}

//客户端登录
export let cgxwClientLogin = (test = false) => {
    if (test) {
        return new Promise((resolve, reject) => {
            resolve({
                "is_weibo": false,
                "user_name": "cbgc_459677",
                "registeer_way": -1,
                "is_qq": false,
                "avatar": "https://cbgccdn.thecover.cn/cf33eae1-a421-45e8-bca6-500454e1d3b1",
                "gender": "1",
                "mobile": "18280485679",
                "nickname": "昵称",
                "user_id": 21715,
                "token": "c896e5bd3f9a4779b76c6d22ba8c16f9",
                "birthday": -1,
                "is_wechat": false,
                "age": 0
            })
        })
    }

    return new Promise((resolve, reject) => {
        try {
            let resolveUser = (user) => {
                if (user.mobile) {
                    if (!user.avatar) user.avatar = 'https://wximg.chuanbaoguancha.cn/Foq8T6IvqYDDFQa9dSzGFqH5ELQj'
                    resolve(user)
                } else {
                    COVERAPP.Method.bindMobile({
                        callback: function (obj) {
                            resolve(JSON.parse(obj))
                        }
                    })
                }
            }

            COVERAPP.Method.GetUser({
                callback: function (userStr) {
                    let user = JSON.parse(userStr)

                    if (user.user_id > 0) {
                        resolveUser(user)
                    } else {
                        COVERAPP.Method.OpenLogin({
                            callback: function (userStr) {
                                let user = JSON.parse(userStr)
                                if (user.user_id > 0) {
                                    resolveUser(user)
                                }
                            }
                        })
                    }
                }

            })
        } catch (e) {
            reject(e)
        }
    })
}


//base64解码
export function BASE64(str) {
    return decodeURIComponent(atob(str).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}

export function dateFormat(fmt, date) {
    let ret;
    const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
    };
    return fmt;
}

//history按日期分类
export function historyDateSort(arr) {
    let map = {}, dest = [];
    for (let i = 0; i < arr.length; i++) {
        let ai = arr[i];
        if (!map[ai.date]) {
            dest.push({
                date: ai.date,
                data: [ai]
            });
            map[ai.date] = ai;
        } else {
            for (let j = 0; j < dest.length; j++) {
                let dj = dest[j];
                if (dj.date == ai.date) {
                    dj.data.push(ai);
                    break;
                }
            }
        }
    }
    return dest
}